<template>
  <div>
    <header class="top-0 text-second w-full fixed h-14 px-3 flex justify-between rounded-b-lg shadow bg-white place-items-center">
      <button class="h-8" @click="$router.push('/basket')">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
        </svg>
      </button>

      <span class="text-xl font-extrabold">Зона доставки</span>

      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
        <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
      </svg>
    </header>
    
    <div class="flex flex-col pt-16 p-3 h-screen">
      <div v-if="loading" class="min-h-full grid grid-cols-1 gap-1 place-items-center">
        <Loading/>
      </div>

      <ul v-else>
        <template v-for="area in $store.getters.deliveryAreas">
          <li class="form_radio_btn" :key="area.id">
            <input type="radio" :id="`area-${area.id}`" name="area" class="appearance-none" @change="$store.commit('setSelectedDeliveryArea', area.id)">
            <label :for="`area-${area.id}`" class="inline-block cursor-pointer mt-2 text-white text-center align-middle bg-primary p-2 w-full rounded-lg text-base font-bold transition-all">
              {{ area.name }}
            </label>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/ui/Loading'

export default {
  data: () => ({
    loading: true,

    deliveryAreas: [],
  }),

  async mounted() {
    this.loading = true
    try {
      await this.$store.dispatch('loadDeliveryAreas')
    } finally {
      this.loading = false
    }
  },

  components: { Loading }
}
</script>

<style>

</style>
